var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-component"},[_c('span',{staticClass:"spinner-border",class:!_vm.large ? 'spinner-border-sm' : '',attrs:{"role":"status","aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }